import React from 'react'
import { useCompanyListContext } from './Context'
import type { DataTableProps } from '@ztechapps/webui.data-tools'
import { DataTable } from '@ztechapps/webui.data-tools'
import { companyListFieldConfig as fieldsCore } from './constants'
import { ListHeader } from './components/ListHeader'
import { CompanyRow } from './components/CompanyRow'
import type { CompanyWithContacts } from '@ztechapps/common.contract'
import type { SetOptional } from 'type-fest'

export type CompanyListProps = SetOptional<DataTableProps<CompanyWithContacts>, 'listResult' | 'fields'>

export const CompanyList = (props: CompanyListProps) => {
  const { listResult } = useCompanyListContext()

  return (
    <DataTable
      {...props}
      fields={fieldsCore}
      listResult={listResult}
      row={CompanyRow}
      head={ListHeader}
      tableOptions={{
        responsive: true,
      }}
    />
  )
}

export * from './Context'
export * from './hooks/useCompanyWithContactsList'
export * from './constants'
export * from './CompanyListDataTool'
